import { getEnvironmentVariables } from 'services/environment-variables/environment-variables';
import { ProductVariablesByApp, VariantVariablesByApp } from '../../generated/graphql';

const APPS_TO_DISPLAY = 3;

export type AppData = {
  appMediaUrl: string | undefined;
  name: string;
  availability: string;
  internalAppId: string;
  key: string;
};

export const createAppDataList = (variablesByApp: ProductVariablesByApp[] | VariantVariablesByApp[]): AppData[] => {
  const { FEATURED_APPS } = getEnvironmentVariables();
  let response: AppData[] = [];

  variablesByApp?.forEach(({ app, availability }) => {
    const { id, image, name, internalAppId } = app;
    response.push({
      appMediaUrl: image || `/Images/NoApp.png`,
      name,
      availability,
      internalAppId: internalAppId || '',
      key: id
    });
  });

  response.sort((a, b) => {
    const indexA = FEATURED_APPS.indexOf(a.internalAppId);
    const indexB = FEATURED_APPS.indexOf(b.internalAppId);
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    if (indexA !== -1) {
      return -1;
    }
    if (indexB !== -1) {
      return 1;
    }
    return a.name.localeCompare(b.name);
  });

  if (response.length > APPS_TO_DISPLAY) {
    const deficit = response.length - APPS_TO_DISPLAY;
    response = response.slice(0, APPS_TO_DISPLAY);

    response.push({
      appMediaUrl: `+${deficit}`,
      name: '',
      availability: 'available',
      internalAppId: '',
      key: `+${deficit}`
    });
  }

  return response;
};
